import { render, staticRenderFns } from "./ElderlyGov2.vue?vue&type=template&id=1a66df6e&scoped=true&"
import script from "./ElderlyGov2.vue?vue&type=script&lang=js&"
export * from "./ElderlyGov2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a66df6e",
  null
  
)

export default component.exports